import { components } from "react-select";

const MenuList = ({ children, ...props }) => (
	<components.MenuList className="advanced-select-menu-list" {...props}>
		<div className="advanced-select-menu-list__container">{children}</div>
	</components.MenuList>
);

export default MenuList;
